/**
 * Created by Timur on 27.07.2026
 */

const BalloonRiseStartWindow = Prefab.createWindow("balloon_rise", "balloon_rise_start_window_prefab_json");
